/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import Swiper from 'swiper/js/swiper';
import AOS from '@/components/aos';
// eslint-disable-next-line no-unused-vars
import CI360 from 'js-cloudimage-360-view/dist/ci360.service';
import Interior360 from '@/libs/showcase-vr/interior-360';
import '~/sass/pages/showcase.scss';
import { initSwipers } from '@/components/showcase-extent';
import '~/js/libs/youtube/lite-yt-embed.css';
import '@/libs/youtube/lite-yt-embed';

const { $ } = window;

const external360Id = 'external360';
let initWindowWidth = $(window).width();

let swiperExteriorWhole = null;
let swiperExteriorRoom = null;
let swiperExtremelyActive = null;
let swiperExtremelyPassive = null;
let swiperHybrid = null;
let swiperPerformance = null;
let swiperAppliance = null;
let swiperVideo = null;
let swiperSpecUpgrad = null;
let swiperPurchase = null;
let swiperShow = null;
let swiperActing = null;
let swiperGallery = null;

function adBarClose() {
  $('#ad-bar .close-button').on('click', () => {
    $('#ad-bar').hide(500);
    // $('.ad-bar-block').css('height', 0);
  });

  // $('#ad-bar').scrollToFixed({
  //   limit: $('#belt').offset().top - $('#global-header').height() + 10,
  //   // limit: $('#belt').offset().top - $('#global-header').height(),
  //   marginTop: $('#global-header').height(),
  //   spacerClass: 'ad-bar-block',
  // });
}

function initialKvSwipers() {
  const commonOptions = {
    slidesPerView: 1,
    centeredSlides: true,
    speed: 600,
  };

  const kvImageSwiperConfig = {
    ...commonOptions,
    navigation: {
      prevEl: '#kv-nav-button-prev',
      nextEl: '#kv-nav-button-next',
    },
    pagination: {
      el: '#kv-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    longSwipesRatio: 0.1,
  };
  const kvSlidesCount = $('#swiper-kv-image .swiper-slide').length - 2;
  // console.log(kvSlidesCount);
  if (kvSlidesCount > 1) {
    kvImageSwiperConfig.loop = true;
  } else {
    kvImageSwiperConfig.loop = false;
    kvImageSwiperConfig.watchOverflow = true;
    kvImageSwiperConfig.pagination = false;
  }
  const kvImageSwiper = new Swiper('#swiper-kv-image', kvImageSwiperConfig);

  // kvContentSwiper.controller.control = kvImageSwiper;
  // kvImageSwiper.controller.control = kvContentSwiper;

  // pause autoplay when mouse enter in '.btn-group'
  const kvBtnGroup = kvImageSwiper.$wrapperEl[0].querySelectorAll('.btn-group');
  $(kvBtnGroup).on('mouseenter', () => {
    kvImageSwiper.autoplay.stop();
  });
  $(kvBtnGroup).on('mouseleave', () => {
    kvImageSwiper.autoplay.start();
  });
}
// eslint-disable-next-line no-unused-vars
function initSwiperExteriorWhole() {
  swiperExteriorWhole = new Swiper('#exterior-whole-car .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '#exterior-whole-car .swiper-button-next',
      prevEl: '#exterior-whole-car .swiper-button-prev',
    },
    on: {
      transitionEnd() {
        const active = swiperExteriorWhole.activeIndex;
        const nowActiveNav = $('[data-nav="exterior-whole-car"].nav-link.active').attr('data-index');
        // console.log(active);
        if (active < nowActiveNav) {
          $('[data-nav="exterior-whole-car"].nav-link').removeClass('active');
          $(`[data-nav="exterior-whole-car"].nav-link[data-index=${nowActiveNav}]`).parent().prev().find('.nav-link')
            .addClass('active');
        } else {
          $(`[data-nav="exterior-whole-car"].nav-link[data-index=${active}]`).trigger('click');
        }
      },
    },
  });

  $('#exterior .scroll-menu-list.fancyboxSlide .nav-link').on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    // console.log(thisIndex);
    swiperExteriorWhole.slideTo(thisIndex, 500, false);
  });
}
// eslint-disable-next-line no-unused-vars
function initSwiperInteriorRoom() {
  swiperExteriorRoom = new Swiper('#interior-room .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '#interior-room .swiper-button-next',
      prevEl: '#interior-room .swiper-button-prev',
    },
    on: {
      transitionEnd() {
        const active = swiperExteriorRoom.activeIndex;
        const nowActiveNav = $('[data-nav="interior-room"].nav-link.active').attr('data-index');
        // console.log(active);
        if (active < nowActiveNav) {
          $('[data-nav="interior-room"].nav-link').removeClass('active');
          $(`[data-nav="interior-room"].nav-link[data-index=${nowActiveNav}]`).parent().prev().find('.nav-link')
            .addClass('active');
        } else {
          $(`[data-nav="interior-room"].nav-link[data-index=${active}]`).trigger('click');
        }
      },
    },
  });
  $('#interior .scroll-menu-list.fancyboxSlide .nav-link').on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    // console.log(thisIndex);
    swiperExteriorRoom.slideTo(thisIndex, 500, false);
  });
}
function initSwiperExtremelyActive() {
  if ($('#extremely-active .swiper-container').length === 0) {
    return;
  }
  swiperExtremelyActive = new Swiper('#extremely-active .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '#extremely-active .swiper-button-next',
      prevEl: '#extremely-active .swiper-button-prev',
    },
    on: {
      transitionEnd() {
        const active = swiperExtremelyActive.activeIndex;
        const activeSlide = swiperExtremelyActive.slides[active];
        console.log(active);
        console.log($(`[data-nav="extremely-active"].nav-link[data-index=${active}]`));
        if ($(`[data-nav="extremely-active"].nav-link[data-index=${active}]`).length === 1) {
          $(`[data-nav="extremely-active"].nav-link[data-index=${active}]`).trigger('click');
          $(activeSlide).find('.icon-list li:eq(0)').trigger('click');
          const child = $(activeSlide).find('.icon-list li').length;
          // console.log(`我有${child}個兄弟姊妹`);
          if (child >= 7) {
            $(activeSlide).find('.icon-list').addClass('item-7group');
          }
        }
      },
    },
  });
  $('#extremely-active .scroll-menu-list.fancyboxSlide .nav-link').on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    console.log(thisIndex);
    swiperExtremelyActive.slideTo(thisIndex, 500, false);
  });
}
function initSwiperExtremelyPassive() {
  if ($('#extremely-passive .swiper-container').length === 0) {
    return;
  }
  swiperExtremelyPassive = new Swiper('#extremely-passive .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '#extremely-passive .swiper-button-next',
      prevEl: '#extremely-passive .swiper-button-prev',
    },
    on: {
      transitionEnd() {
        const active = swiperExtremelyPassive.activeIndex;
        console.log(active);
        console.log($(`[data-nav="extremely-passive"].nav-link[data-index=${active}]`));
        if ($(`[data-nav="extremely-passive"].nav-link[data-index=${active}]`).length === 1) {
          $(`[data-nav="extremely-passive"].nav-link[data-index=${active}]`).trigger('click');
        }
      },
    },
  });
  $('#extremely-passive .scroll-menu-list.fancyboxSlide .nav-link').on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    console.log(thisIndex);
    swiperExtremelyPassive.slideTo(thisIndex, 500, false);
  });

  const thisSW = $('#extremely-passive .scroll-menu-list')[0].scrollWidth;
  const thisOW = $('#extremely-passive .scroll-menu-list')[0].offsetWidth;
  const thisS = $('#extremely-passive .scroll-menu');
  if (thisSW === thisOW) {
    thisS.addClass('justify-center');
  }
}
// eslint-disable-next-line no-unused-vars
function initSwiperHybrid() {
  swiperHybrid = new Swiper('#hybrid .swiper-hybrid.swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '#hybrid .swiper-button-hybrid.swiper-button-next',
      prevEl: '#hybrid .swiper-button-hybrid.swiper-button-prev',
    },
    on: {
      transitionEnd() {
        const active = swiperHybrid.activeIndex;
        // console.log(active);
        // console.log($(`[data-nav="hybrid"].nav-link[data-index=${active}]`));
        if ($(`[data-nav="hybrid"].nav-link[data-index=${active}]`).length === 1) {
          $(`[data-nav="hybrid"].nav-link[data-index=${active}]`).trigger('click');
        }
      },
    },
  });
  $('.scroll-menu-list.fancyboxSlide .nav-link').on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    // console.log(thisIndex);
    swiperHybrid.slideTo(thisIndex, 500, false);
  });
}

function initPerformanceSwipers() {
  swiperPerformance = new Swiper('#performance .swiper-container', {
    slidesPerView: 1.25,
    centerInsufficientSlides: true,
    centeredSlides: true,
    navigation: {
      nextEl: '#performance .swiper-button-next',
      prevEl: '#performance .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
  });
}
function extremelyActiveCollapse() {
  $('.icon-list li').on('click', function clickIcon() {
    const iconID = $(this).attr('data-icon');
    console.log(iconID);
    $(this).siblings('li').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.tab-pane').find('.img img').hide();
    $(this).closest('.tab-pane').find(`[data-img=${iconID}]`).fadeIn(200);
    $(this).closest('.tab-pane').find('.text').hide();
    $(this).closest('.tab-pane').find(`[data-text=${iconID}]`).fadeIn(200);
    const $box = $(this).closest('.tab-pane').find(`[data-text=${iconID}] p`);

    if ($box[0].scrollHeight > $box[0].clientHeight) {
      if (!$box.hasClass('once')) {
        $(this).closest('.tab-pane').find(`[data-text=${iconID}] p`).after('<a href="javascript:;" class="link-popup d-block" data-fancybox="" data-src="#read-more">閱讀更多</a>');
        $box.addClass('once');
      }
    }
  });
}
function initSwiperVideo() {
  if ($('#car-video .swiper-wrapper').length > 0) {
    // const tag = document.createElement('script');
    // tag.src = 'https://www.youtube.com/iframe_api';
    // const firstScriptTag = document.getElementsByTagName('script')[0];
    // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // 3. This function creates an <iframe> (and YouTube player)

    const initPlayer = function init(element) {
      const player = element.querySelector('.video-iframe');
      const button = element.querySelector('.video-play');
      // const ytplayer = new YT.Player(player, {
      //   playerVars: {
      //     autoplay: 0,
      //     modestbranding: 1,
      //     controls: 0,
      //     rel: 0,
      //   },
      //   videoId: element.dataset.id,
      // });

      button.addEventListener('click', () => {
        // console.log(ytplayer);
        // console.log(ytplayer.getPlayerState());
        // ytplayer.playVideo();
        // switch (ytplayer.getPlayerState()) {
        //   case 1:
        //     ytplayer.stopVideo();
        //     $(button).removeClass('playing');
        //     break;
        //   default:
        //     ytplayer.playVideo();
        //     $(button).addClass('playing');
        //     break;
        // }
      });
    };

    swiperVideo = new Swiper('#car-video .swiper-container', {
      slidesPerView: 1.25,
      centerInsufficientSlides: true,
      centeredSlides: true,
      navigation: {
        nextEl: '#car-video .swiper-button-next',
        prevEl: '#car-video .swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    }).on('slideChange', () => {
      // const isVideo = swiperVideo.slides[swiperVideo.previousIndex].querySelector('.video');
      // if (isVideo) {
      //   YT.get(isVideo.querySelector('iframe').id).stopVideo();
      //   console.log(isVideo.querySelector('iframe').id);
      // }
      const isVideo = swiperVideo.slides[swiperVideo.previousIndex].querySelector('.video');
      if (isVideo) {
        const videoId = isVideo.dataset.id;
        const iframe = $(`#car-video lite-youtube[videoid=${videoId}] iframe`).get(0);
        if (!iframe) {
          return;
        }
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
        }), '*');
      }
    });

    // window.onYouTubePlayerAPIReady = function ready() {
    //   const container = document.querySelectorAll('.video');
    //   for (let i = 0; i < container.length; i += 1) {
    //     initPlayer(container[i]);
    //   }
    // };
  }
}
function initApplianceSwipers() {
  swiperAppliance = new Swiper('#appliance .swiper-container', {
    slidesPerView: 1.25,
    centerInsufficientSlides: true,
    centeredSlides: true,
    navigation: {
      nextEl: '#appliance .swiper-button-next',
      prevEl: '#appliance .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
  });
}

function initSpecPetrolSwipers() {
  swiperAppliance = new Swiper('#spec #spec-petrol .swiper-container', {
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 25,
    longSwipesMs: 1000,
    navigation: {
      nextEl: '#spec #spec-petrol .swiper-button-next',
      prevEl: '#spec #spec-petrol .swiper-button-prev',
    },
    breakpoints: {
      769: {
        centerInsufficientSlides: true,
        slidesPerView: 2.25,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        centerInsufficientSlides: true,
        slidesPerView: 3.25,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}

function initSpecHybridSwipers() {
  swiperAppliance = new Swiper('#spec #spec-hybrid .swiper-container', {
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 25,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    longSwipesMs: 1000,
    navigation: {
      nextEl: '#spec #spec-hybrid .swiper-button-next',
      prevEl: '#spec #spec-hybrid .swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 2.25,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 3.25,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}

function initSpecUpgradeSwipers() {
  swiperSpecUpgrad = new Swiper('#spec #spec-upgrade .swiper-container', {
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 25,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    longSwipesMs: 1000,
    navigation: {
      nextEl: '#spec #spec-upgrade .swiper-button-next',
      prevEl: '#spec #spec-upgrade .swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 2.25,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}
function initSwiperPurchase() {
  swiperPurchase = new Swiper('#car-purchase .swiper-news', {
    slidesPerView: 1.25,
    centeredSlides: true,
    navigation: {
      nextEl: '#car-purchase .swiper-button-next',
      prevEl: '#car-purchase .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}
function initSwiperShow() {
  swiperShow = new Swiper('#recommend .swiper-container', {
    slidesPerView: 'auto',
    centeredSlides: true,
    // centerInsufficientSlides: true,
    freeMode: true,
    freeModeSticky: true,
    freeModeMomentumVelocityRatio: 0.5,
    freeModeMomentumRatio: 0.5,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '#recommend .swiper-button-next',
      prevEl: '#recommend .swiper-button-prev',
    },
    breakpoints: {
      768: { // 當螢幕寬度 >= 768
        centerInsufficientSlides: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
      },
      1024: {
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        centeredSlides: true,
      },
      1200: {
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        centeredSlides: true,
      },
      1440: {
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        centeredSlides: true,
      },
    },
  });
}
function initSwiperHybridActing() {
  swiperActing = new Swiper('#acting-principle .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    allowTouchMove: false,
    // nested: true,
    // resistanceRatio: 0,
    navigation: {
      nextEl: '#acting-principle .swiper-button-next',
      prevEl: '#acting-principle .swiper-button-prev',
    },
    breakpoints: {
      768: { // 當螢幕寬度 >= 768
        centeredSlides: false,
        slidesPerView: 2,
      },
      1024: {
        centeredSlides: false,
        slidesPerView: 3,
      },
      1200: {
        centeredSlides: false,
        slidesPerView: 5,
        noSwiping: true,
      },
    },
  });
}

// eslint-disable-next-line no-unused-vars
// function initSwiperGallery() {
//   swiperGallery = new Swiper('#gallery-swiper .swiper-container', {
//     slidesPerView: 1,
//     spaceBetween: 10,
//     centeredSlides: true,
//     observer: true,
//     observeParents: true,
//     navigation: {
//       nextEl: '#gallery-swiper .swiper-button-next',
//       prevEl: '#gallery-swiper .swiper-button-prev',
//     },
//     on: {
//       transitionEnd() {
//         const active = swiperGallery.activeIndex;
//         const nowActiveNav = $('[data-nav="gallery-swiper"].nav-link.active').attr('data-index');
//         // console.log(active);
//         if (active < nowActiveNav) {
//           $('[data-nav="gallery-swiper"].nav-link').removeClass('active');
//           $(`[data-nav="gallery-swiper"].nav-link[data-index=${nowActiveNav}]`).parent().prev().find('.nav-link')
//             .addClass('active');
//         } else {
//           $(`[data-nav="gallery-swiper"].nav-link[data-index=${active}]`).trigger('click');
//         }
//       },
//     },
//   });
//   $('#gallery .scroll-menu-list.fancyboxSlide .nav-link').on('click', function popIndex() {
//     const thisIndex = $(this).attr('data-index');
//     $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
//     $(this).addClass('active');
//     // console.log(thisIndex);
//     swiperGallery.slideTo(thisIndex, 500, false);
//   });
// }

// function navScrollToFixed() {
//   let beltH = null;
//   const wW = $(window).width();
//   if (wW < 1024) {
//     beltH = 50;
//     $('body').attr('data-offset', beltH);
//   } else {
//     beltH = 60;
//     $('body').attr('data-offset', 270);
//   }

//   $('#global-header').scrollToFixed({
//     limit: $('#belt').offset().top - $('#global-header').height(),
//     removeOffsets: true,
//     // dontSetWidth: true,
//     offsets: false,
//   });

//   $('#belt').scrollToFixed();

//   $('#belt a[href*="#"]').on('click', function Amooth() {
//     const bW = $('#belt .slider').width();
//     if (this.hash !== '') {
//       const { hash } = this;

//       const pos = $(this).parent().position().left;
//       const posWidth = $(this).parent().width();

//       if (pos + posWidth + 100 > bW) {
//         $('#belt .icon-rarrS')[0].click();
//       } else {
//         $('#belt .icon-larrS')[0].click();
//       }

//       $('#belt a[href*="#"]').removeClass('active');
//       $(this).addClass('active');

//       $('html, body').stop().animate({
//         scrollTop: $(hash).offset().top - beltH + 5,
//       }, 800,
//       () => {
//         if (window.history.pushState) {
//           window.history.pushState(null, null, hash);
//         } else {
//           window.location.hash = hash;
//         }
//       });
//       return false;
//     }
//   });

//   $('#belt .arrow.icon-rarrS').on('click', function Amooth() {
//     const lastItem = $('#belt li').last().position().left;
//     const lastW = $('#belt li').last().width();
//     const arrowW = $(this).width();
//     const sliderW = $('#belt .slider').width();
//     const pos = sliderW - lastItem - lastW - arrowW;
//     // console.log('按了Ｒ');
//     $('#belt .slider').stop().animate({
//       left: pos,
//     });
//     $(this).fadeOut(300);
//     $('#belt .arrow.icon-larrS').fadeIn(300);
//   });

//   $('#belt .arrow.icon-larrS').on('click', function Amooth() {
//     $('#belt .slider').stop().animate({
//       left: 0,
//     });
//     // console.log('按了Ｌ');
//     $(this).fadeOut(300);
//     $('#belt .arrow.icon-rarrS').fadeIn(300);
//   });
// }

function navScrollToFixed() {
  let beltH = null;
  const wW = $(window).width();
  if (wW < 1024) {
    beltH = 50;
    $('body').attr('data-offset', beltH);
  } else {
    beltH = 60;
    $('body').attr('data-offset', 270);
  }

  $('#global-header').scrollToFixed({
    limit: $('#belt').offset().top - $('#global-header').height(),
    zIndex: 99999,
  });

  $('#belt').scrollToFixed();

  $('#belt a[href*="#"]').on('click', function Amooth() {
    const bW = $('#belt .slider').width();
    if (this.hash !== '') {
      const { hash } = this;

      const pos = $(this).parent().position().left;
      const posWidth = $(this).parent().width();

      if (pos + posWidth + 100 > bW) {
        $('#belt .icon-rarrS')[0].click();
      } else {
        $('#belt .icon-larrS')[0].click();
      }

      $('#belt a[href*="#"]').removeClass('active');
      $(this).addClass('active');

      $('html, body').stop().animate({
        scrollTop: $(hash).offset().top - beltH + 5,
      }, 800,
      () => {
        if (window.history.pushState) {
          window.history.pushState(null, null, hash);
        } else {
          window.location.hash = hash;
        }
      });
      return false;
    }
  });
}
function mobileNavScroll() {
  const $navHoles = $('#belt .holes');
  const $navSelect = $('#belt .select');
  $('#belt .select').on('click', () => {
    if ($navHoles.hasClass('active')) {
      $navHoles.removeClass('active');
    } else {
      $navHoles.addClass('active');
    }
  });
  $('#belt .slider a').on('click', function clickLink() {
    const sectionName = $(this).text();
    $navHoles.removeClass('active');
    $navSelect.find('span').text(sectionName);
  });
  $(window).scroll(() => {
    const unitName = $('#belt .slider li a.active').text();
    $('#belt .select span').text(unitName);
  });
}
function pcNavScroll() {
  if ($('#belt .slider li a').hasClass('active')) {
    const $unitNav = $('#belt .slider li a.active');
    const bW = $('#belt .slider').width();
    const pos = $unitNav.parent().position().left;
    const posWidth = $unitNav.parent().width();

    if (pos + posWidth + 100 > bW) {
      if ($('#belt .arrow.icon-rarrS').hasClass('on') !== true) {
        $('#belt .icon-rarrS').trigger('click');
      }
    } else if ($('#belt .arrow.icon-larrS').hasClass('on') !== true) {
      $('#belt .icon-larrS').trigger('click');
    }
  }

  $('#belt .arrow.icon-rarrS').on('click', function Amooth() {
    const lastItem = $('#belt li').last().position().left;
    const lastW = $('#belt li').last().width();
    const arrowW = $(this).width();
    const sliderW = $('#belt .slider').width();
    const pos = sliderW - lastItem - lastW - arrowW;
    // console.log('按了Ｒ');
    $('#belt .slider').stop().animate({
      left: pos,
    });
    $(this).fadeOut(300);
    $('#belt .arrow.icon-larrS').fadeIn(300);
  });

  $('#belt .arrow.icon-larrS').on('click', function Amooth() {
    $('#belt .slider').stop().animate({
      left: 0,
    });
    // console.log('按了Ｌ');
    $(this).fadeOut(300);
    $('#belt .arrow.icon-rarrS').fadeIn(300);
  });
}

function collapseButton() {
  $('[data-toggle="collapse"]').click(function btnTooggle() {
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      $(this).text('收合內容');
    } else {
      $(this).text('展開內容');
    }
  });
}
function exteriorFancybox() {
  const fancyboxDefaultsExteriorWhole = {
    buttons: [
      'close',
    ],
    touch: true,
    backFocus: false,
    baseClass: 'figure-slide',
    infobar: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    clickContent(current) {
      if (current.type === 'image') {
        return false;
      }
    },
    caption() {
      return $(this).find('figcaption').html();
    },
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">'
        + '<i class="icon icon-close"></i>'
        + '</button>',
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
    },
    onInit(instance, current) {
      // console.log(instance)
      if ($.fancybox.isMobile) {
        const a = $('body,html').scrollTop() * -1;
        $('body,html').css('top', a).addClass('fancybox-iosfix');
        // console.log(a)
      }
    },
    afterClose() {
      let offset;
      if ($('body,html').hasClass('fancybox-iosfix')) {
        offset = parseInt(document.body.style.top, 10);
        $('body,html').removeClass('fancybox-iosfix').css('top', '').scrollTop(offset * -1);
      }
    },
    beforeClose(instance) {
      const FBcurrIndex = instance.currIndex;

      const FBswiperSlide = $(`[data-fancybox='exterior-whole']:eq(${FBcurrIndex})`).closest('.swiper-slide').index();
      swiperExteriorWhole.slideTo(FBswiperSlide, 0);
    },
  };

  const fancyboxDefaultsExteriorRoom = {
    buttons: [
      'close',
    ],
    touch: true,
    backFocus: false,
    baseClass: 'figure-slide',
    infobar: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    clickContent(current) {
      if (current.type === 'image') {
        return false;
      }
    },
    caption() {
      return $(this).find('figcaption').html();
    },
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">'
        + '<i class="icon icon-close"></i>'
        + '</button>',
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
    },
    onInit(instance, current) {
      // console.log(instance)
      if ($.fancybox.isMobile) {
        const a = $('body,html').scrollTop() * -1;
        $('body,html').css('top', a).addClass('fancybox-iosfix');
        // console.log(a)
      }
    },
    afterClose() {
      let offset;
      if ($('body,html').hasClass('fancybox-iosfix')) {
        offset = parseInt(document.body.style.top, 10);
        $('body,html').removeClass('fancybox-iosfix').css('top', '').scrollTop(offset * -1);
      }
    },
    beforeClose(instance) {
      const FBcurrIndex = instance.currIndex;

      const FBswiperSlide = $(`[data-fancybox='interior-room']:eq(${FBcurrIndex})`).closest('.swiper-slide').index();
      swiperExteriorRoom.slideTo(FBswiperSlide, 0);
    },
  };

  const fancyboxDefaultsGallery = {
    buttons: [
      'close',
    ],
    touch: true,
    backFocus: false,
    baseClass: 'figure-slide',
    infobar: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    clickContent(current) {
      if (current.type === 'image') {
        return false;
      }
    },
    caption() {
      return $(this).find('figcaption').html();
    },
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">'
        + '<i class="icon icon-close"></i>'
        + '</button>',
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
    },
    onInit(instance, current) {
      // console.log(instance)
      if ($.fancybox.isMobile) {
        const a = $('body,html').scrollTop() * -1;
        $('body,html').css('top', a).addClass('fancybox-iosfix');
        // console.log(a)
      }
    },
    afterClose() {
      let offset;
      if ($('body,html').hasClass('fancybox-iosfix')) {
        offset = parseInt(document.body.style.top, 10);
        $('body,html').removeClass('fancybox-iosfix').css('top', '').scrollTop(offset * -1);
      }
    },
    beforeClose(instance) {
      const FBcurrIndex = instance.currIndex;

      const FBswiperSlide = $(`[data-fancybox='gallery-swiper']:eq(${FBcurrIndex})`).closest('.swiper-slide').index();
      swiperGallery.slideTo(FBswiperSlide, 0);
    },
  };

  $('[data-fancybox="exterior-whole"]').fancybox(fancyboxDefaultsExteriorWhole);
  $('[data-fancybox="interior-room"]').fancybox(fancyboxDefaultsExteriorRoom);
  $('[data-fancybox="gallery-swiper"]').fancybox(fancyboxDefaultsGallery);
}

function popupInstructionScroll() {
  $('body').on('click', '[data-instruction]', function popScroll() {
    const instructionCode = $(this).attr('data-instruction');

    setTimeout(() => {
      const $codeTop = $(`[data-code=${instructionCode}]`).position().top;
      $(`[data-code=${instructionCode}]`).siblings('li').removeClass('active');
      $(`[data-code=${instructionCode}]`).addClass('active');

      $('ul.instruction-list').animate({
        scrollTop: $codeTop,
      }, 500);
    }, 250);
  });
}

function initHeight360() {
  $('.nav-link#interiorWith360-tab').on('click', () => {
    const height360 = $('#externalWith360').height();
    // console.log(height360);
    // $('.interior-360 .roll360').css('height', height360);
  });
}

function hasOwerflow() {
  $('.extremely-group p').each(function Owerflow(index) {
    const sH = $(this)[0].scrollHeight;
    const cH = $(this)[0].clientHeight;
    if (sH > cH) {
      $(this).after('<a href="javascript:;" class="link-popup d-block" data-fancybox="" data-src="#read-more">閱讀更多</a>');
      $(this).addClass('once');
    }
  });
}

function hasIconList7() {
  const parent = $('#extremely-active .icon-list');
  parent.each((index, element) => {
    // element.find('li').length();
    // console.log(index);
  });
}

$(document).ready(() => {
  console.log('showcase init');
  const pathArr = /\/showroom\/([^/]+)\//.exec(window.location.pathname);
  const carname = (pathArr && pathArr.length > 1) ? pathArr[1] : 'toyota';
  let external360 = null;

  initialKvSwipers();
  // initSwiperExteriorWhole();
  initSwiperExtremelyActive();
  initSwiperExtremelyPassive();
  // initSwiperHybrid();
  // initSwiperInteriorRoom();

  initPerformanceSwipers();
  initSwiperVideo();
  extremelyActiveCollapse();
  initApplianceSwipers();
  initSwipers();
  initSpecPetrolSwipers();
  initSpecHybridSwipers();
  // initSpecUpgradeSwipers();
  initSwiperPurchase();
  initSwiperShow();
  initSwiperHybridActing();
  // initSwiperGallery();

  collapseButton();
  navScrollToFixed();
  mobileNavScroll();
  // exteriorFancybox();
  popupInstructionScroll();
  adBarClose();
  hasIconList7();

  function initExternal360(index = 1) {
    external360 = new CI360(document.getElementById(external360Id), null, null, index);
  }

  function destroyExternal360() {
    if (external360) {
      external360.destroy();
      external360 = null;
    }
  }

  function reInitExternal360() {
    let index = 1;
    if (external360 != null) {
      index = external360.activeImage;
    }
    destroyExternal360();
    initExternal360(index);
  }

  $('.js-360-switch-color').on('click', (event) => {
    event.preventDefault();

    const target = $(event.currentTarget);
    const targetFolder = target.data('folder');
    const targetFilename = target.data('filename');
    const targetColorname = target.data('name');
    const targetAmount = target.data('amount');
    const canvas = $('.cloudimage-360');
    const colorName = $('.color-name');
    canvas.attr('data-folder', targetFolder);
    canvas.attr('data-filename', targetFilename);
    colorName.text(targetColorname);
    canvas.attr('data-amount', targetAmount);
    $('.js-360-switch-color').removeClass('active');
    target.addClass('active');

    const targetColor = target.data('colorsno');
    const $colorCarImg = $('#externalWith360 .img');
    $('#externalWith360 .img img').hide();
    if (targetAmount === 0) {
      const currentImg = $(`#externalWith360 .img [data-colorsno=${targetColor}]`);
      currentImg.attr('src', currentImg.data('src'));
      currentImg.show();
      canvas.hide();
      $colorCarImg.show();
    } else {
      canvas.show();
      $colorCarImg.hide();
      reInitExternal360();
    }
  });
  const isColor360 = $('#external360').data('amount') > 0;
  if (isColor360) {
    $('#externalWith360 .img').hide();
  }

  if ($('#interiorWith360 .roll360').length > 0) {
    $('#interiorWith360 .roll360').each((i, e) => {
      // eslint-disable-next-line no-new
      new Interior360($(e), carname);
    });
  }

  $('.btn-note-collapse').on('click', () => {
    $('body, html').stop().animate({
      scrollTop: $('#note-top').offset().top - 50,
    }, 500);
    console.log('GOOOO');
  });

  setTimeout(() => {
    initHeight360();
  }, 2000);

  if (initWindowWidth >= 1024) {
    pcNavScroll();
  }

  $(window).scroll(() => {
    initWindowWidth = $(window).width();
    if (initWindowWidth >= 1024) {
      pcNavScroll();
    }
  });

  $(window).on('resize', () => {
    initWindowWidth = $(window).width();
    if (external360) {
      external360.update();
    }
    if (initWindowWidth < 1024) {
      $('#belt .arrow').css('display', '');
    }
    setTimeout(() => {
      initHeight360();
    }, 2000);
  });

  AOS.refresh();
  initExternal360();
  hasOwerflow();
});
